export enum InstanceStatus {
    OPEN = 'OPEN',
    RESERVED = 'RESERVED',
    PROCESSING_PAYMENT = 'PROCESSING_PAYMENT',
    SOLD = 'SOLD',
    ALL = 'ALL',
    MINTING = 'MINTING'
}
